import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "position-relative" }
const _hoisted_9 = { class: "text-danger" }
const _hoisted_10 = { class: "col-lg-6" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "position-relative" }
const _hoisted_13 = { class: "text-danger" }

import { useField, useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import * as zod from "zod";
import { onMounted, ref } from "vue";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { toast } from "vue-sonner";
import { useVesselType } from "@/stores/master/vessel-type";
import {
  VesselTypePayload,
  VesselTypeResponse,
} from "@/types/interface/vessel-type";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateVesselType',
  setup(__props) {

const idVesselType = ref<string>("");
const isEdit = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const vesselTypeStore = useVesselType();
const detailVesselType = ref<VesselTypeResponse>();

const validationSchema = toTypedSchema(
  zod.object({
    name: zod.string().nonempty({ message: "Name is required" }),
    code: zod.string().nonempty({ message: "Code is required" }),
  })
);

const { handleSubmit, errors } = useForm({
  validationSchema,
});

const { value: name } = useField<string>("name");
const { value: code } = useField<string>("code");

const onSubmit = handleSubmit(async (values) => {
  isLoading.value = true;
  const payloadVesselType: VesselTypePayload = {
    name: name.value,
    code: code.value,
  };

  const responseApi = ref<any>();

  if (isEdit.value == true) {
    responseApi.value = await vesselTypeStore.dispatchUpdate(
      idVesselType.value,
      payloadVesselType
    );
  } else {
    responseApi.value = await vesselTypeStore.dispatchCreate(payloadVesselType);
  }

  const { success, message } = responseApi.value;
  if (success == true) {
    setTimeout(() => {
      isLoading.value = false;
      toast.success(
        isEdit.value
          ? "Vessel Type Successfully Updated"
          : "Vessel Type Successfully Added"
      );
      router.push("/master/vessel-type");
    }, 1000);
  } else {
    isLoading.value = false;
    toast.error(message);
  }
});

const loadDetailVesselType = async () => {
  const { success, message } = await vesselTypeStore.dispatchDetail(
    idVesselType.value
  );
  if (success) {
    detailVesselType.value = await vesselTypeStore?.vesselType?.data;
    name.value = detailVesselType.value?.name;
    code.value = detailVesselType.value?.code;
  }
};

onMounted(() => {
  if (router.currentRoute.value.params.id != undefined) {
    isEdit.value = true;
    idVesselType.value = router.currentRoute.value.params.id.toString();
    loadDetailVesselType();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }, [
            _createElementVNode("h3", { class: "mb-0" }, "Form Create Vessel Type"),
            _createElementVNode("a", {
              class: "btn btn-danger fw-semibold text-white px-3",
              type: "button",
              href: "/master/vessel-type"
            }, [
              _createElementVNode("i", { class: "ri-arrow-drop-left-line text-gray-light" }),
              _createTextVNode(" Back To List Vessel Type ")
            ])
          ], -1)),
          (isLoading.value)
            ? (_openBlock(), _createBlock(BaseLoading, {
                key: 0,
                text: "Processing Data..."
              }))
            : _createCommentVNode("", true),
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("form", {
                key: 1,
                onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
                class: "row g-3 needs-validation form"
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[3] || (_cache[3] = _createElementVNode("label", {
                        for: "name",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Name "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_8, [
                        _withDirectives(_createElementVNode("input", {
                          name: "name",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(name) ? (name).value = $event : null)),
                          placeholder: "Name",
                          type: "text",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(name)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(errors).name), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[4] || (_cache[4] = _createElementVNode("label", {
                        for: "code",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Code "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_12, [
                        _withDirectives(_createElementVNode("input", {
                          name: "code",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(code) ? (code).value = $event : null)),
                          placeholder: "Vessel Type Code",
                          type: "text",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(code)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(errors).code), 1)
                    ])
                  ]),
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "col-12 mt-5" }, [
                    _createElementVNode("button", {
                      class: "btn btn-primary fw-semibold text-white py-2 px-3",
                      type: "submit"
                    }, " Save ")
                  ], -1))
                ])
              ], 32))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})